import '../assets/styles/global.scss';
import React, { useEffect, useRef, useState } from 'react';

import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";

function Banner({openChat}) {
    const navigate = useNavigate();


        const [goftinoReady, setGoftinoReady] = useState(false);
    
        useEffect(() => {
            const handleGoftinoReady = () => {
              setGoftinoReady(true);
            };
          
            // Check immediately if already loaded
            if (window.Goftino) {
              setGoftinoReady(true);
            } else {
              // Wait for it to load
              window.addEventListener('goftino_ready', handleGoftinoReady);
            }
          
            return () => {
              window.removeEventListener('goftino_ready', handleGoftinoReady);
            };
          }, []);

          const handleClickChat = () => {
            openChat(); // Parent handles readiness now
          };
    
  return (
    <div className="banner-container">
        <img src={require('../assets/images/banner_country.png')} alt='banner image'/>
        <div className='banner-text-container'>
            <div className='texts'>
                <h1>بار خود را با وطن</h1>
                <h1>سریع و به‌صرفه و ایمن</h1>
                <h1>ارسال کنید به هر جای وطن</h1>

                <h6>سریع‌ترین سامانه ارسال روزانه و بی‌وقفه خرده‌بار به سراسر کشور.</h6>
            </div>

            <div className='options'>
                <a onClick={handleClickChat}>ارسال بار</a>
                <div className='separator'></div>
                <a onClick={handleClickChat}>رهگیری بار</a>
                <div className='separator'></div>
                <a href='/contact#department-map' target='_blank' className='last-opt'>نمایندگی‌ها</a>
            </div>

            {/* <div className='search-cargo'>
                <button>رهگیری بار</button>
                <input type='number' placeholder='شماره رهگیری یا بارکد خود را وارد کنید'/>
            </div> */}
        </div>
    </div>
  );
}

export default Banner;
